import { pickBy } from 'lodash';
import { Channel } from 'redux-saga';
import ISocketHandler from '../../../../api/sockets/ISocketHandler';
import ISocketMessage from '../../../../api/sockets/ISocketMessage';
import checkUndefinedableValue from '../../../../utils/checkUndefinedableValue';
import { serializeTaskComment } from '../../../serializers/tasks';
import { WS_ADD_TASK_COMMENT_IN_LIST } from '../../../actions/tasks';

class ActiveTaskCommentsChannelHandler implements ISocketHandler {
  socketChannel: Channel<Record<string, unknown>>;

  constructor(channel: Channel<Record<string, unknown>>) {
    this.socketChannel = channel;
  }

  update(): void {
    return undefined;
  }

  create(message: ISocketMessage): void {
    const comment = serializeTaskComment(message.data.task_comment);

    this.socketChannel.put({
      type: WS_ADD_TASK_COMMENT_IN_LIST,
      payload: { comment },
    });
  }

  delete(): void {
    return undefined;
  }

  info(): void {
    return undefined;
  }
}

export default ActiveTaskCommentsChannelHandler;
